import queryString from 'query-string';
import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';

import organizationsActions from '@/actions/organizationsActions';
import workspaceActions from '@/actions/workspaceActions';
import { BETA_FEATURE_LLM_EVAL } from '@/lib/betaFeatures';
import { useUpdateUserSettingsMutation } from '@shared/api';
import { APPLICATION_TYPE } from '@shared/constants';
import useAllUserWorkspaces from './workspace/useAllUserWorkspaces';
import useBetaFeatureEnabled from './useBetaFeatureEnabled';

export const useCheckApplicationType = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { data: workspaces } = useAllUserWorkspaces();
  const isLLMEvalEnabled = useBetaFeatureEnabled(BETA_FEATURE_LLM_EVAL);
  const updateUserSettingsMutation = useUpdateUserSettingsMutation();
  const { from, from_workspace_name, ...restSearchProps } = queryString.parse(
    window.location.search
  );
  const fromRef = useRef(typeof from === 'string' ? from.toUpperCase() : '');
  const fromWorkspaceNameRef = useRef(from_workspace_name);

  const restSearch = queryString.stringify(restSearchProps);
  useEffect(() => {
    if (!isLLMEvalEnabled || fromRef.current !== APPLICATION_TYPE.llm) return;

    updateUserSettingsMutation.mutate({
      updates: { userAppType: APPLICATION_TYPE.llm }
    });

    const workspace = workspaces?.find(workspace => {
      return workspace.name === fromWorkspaceNameRef.current;
    });

    if (!workspace) return;

    // @todo: improve, collision with the `useEffect` in the routes that updates
    // the workspace name at the same time (when `useAllUserWorkspaces` is loaded)
    setTimeout(() => {
      dispatch(workspaceActions.setActiveWorkspaceName(workspace.name));
      dispatch(
        organizationsActions.setActiveOrganization(workspace.organizationId)
      );
    });

    history.push({ search: restSearch });
  }, [dispatch, history, isLLMEvalEnabled, restSearch, workspaces]);
};
